import { Capacitor } from '@capacitor/core';

/**
 * Native iOS Sign in with Apple wrapper.
 *
 * - iOS native build: AuthenticationServices framework üzerinden identity_token alır.
 * - Diğer platformlar: undefined döner; UI'da buton gizlenmelidir.
 */
export const isAppleSignInAvailable = () => {
  try {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  } catch (_) {
    return false;
  }
};

export const triggerAppleSignIn = async () => {
  if (!isAppleSignInAvailable()) {
    throw new Error('Sign in with Apple sadece iOS native uygulamada kullanılabilir.');
  }
  // Plugin runtime-only import — web build'inde paketlenmez.
  const mod = await import('@capacitor-community/apple-sign-in');
  const SignInWithApple = mod.SignInWithApple;
  const options = {
    clientId: 'com.dekosta.game',
    redirectURI: 'https://api.dekosta.com/api/auth/apple/callback',
    scopes: 'email name',
    state: '',
    nonce: '',
  };
  const result = await SignInWithApple.authorize(options);
  // result.response: { user, identityToken, authorizationCode, email?, givenName?, familyName? }
  return result?.response || null;
};
